module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:top",
      value: (_vm.layer.name + ', \ntop: ' + _vm.layer.frame.y + ', left: ' + _vm.layer.frame.x + ', width: ' + _vm.layer.frame.width + ', height: ' + _vm.layer.frame.height),
      expression: "layer.name  +', \\ntop: ' + layer.frame.y + ', left: ' + layer.frame.x + ', width: ' + layer.frame.width + ', height: ' + layer.frame.height",
      arg: "top"
    }],
    staticClass: "layer",
    style: ({
      position: "absolute",
      left: "" + (_vm.layer.frame.x * _vm.artboardFactor) + "px",
      top: "" + (_vm.layer.frame.y * _vm.artboardFactor) + "px",
      width: "" + (_vm.layer.frame.width * _vm.artboardFactor) + "px",
      height: "" + (_vm.layer.frame.height * _vm.artboardFactor) + "px",
      visibility: "" + (_vm.layer.isVisible ? "visibile" : "hidden"),
      boxSizing: "border-box"
    }),
    attrs: {
      "data-name": _vm.layer.name,
      "data-id": _vm.layer.do_objectID
    }
  }, _vm._l((_vm.layer.layers), function(child) {
    return (_vm.layer.isVisible) ? _c('layer', {
      key: _vm.layer.do_objectID,
      attrs: {
        "layer": child,
        "artboard-width": _vm.artboardWidth,
        "artboard-factor": _vm.artboardFactor
      }
    }) : _vm._e()
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7aeb26d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layer.vue
// module id = 119
// module chunks = 1